/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiError,
  ChatRoom,
  HealthStatus
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateChatRoomUrl = () => {




  return `/api/chat/rooms`
}

/**
 * Creates a new in-memory chat room. Returns a unique room ID. All data is erased when the room closes.
 * @summary Create an ephemeral chat room
 */
export const createChatRoom = async ( options?: RequestInit): Promise<ChatRoom> => {

  return customFetch<ChatRoom>(getCreateChatRoomUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateChatRoomMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChatRoom>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createChatRoom>>, TError,void, TContext> => {

const mutationKey = ['createChatRoom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChatRoom>>, void> = () => {


          return  createChatRoom(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateChatRoomMutationResult = NonNullable<Awaited<ReturnType<typeof createChatRoom>>>

    export type CreateChatRoomMutationError = ErrorType<unknown>

    /**
 * @summary Create an ephemeral chat room
 */
export const useCreateChatRoom = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChatRoom>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createChatRoom>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateChatRoomMutationOptions(options));
    }

export const getGetChatRoomUrl = (roomId: string,) => {




  return `/api/chat/rooms/${roomId}`
}

/**
 * Returns current participant count and room status.
 * @summary Get chat room info
 */
export const getChatRoom = async (roomId: string, options?: RequestInit): Promise<ChatRoom> => {

  return customFetch<ChatRoom>(getGetChatRoomUrl(roomId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetChatRoomQueryKey = (roomId: string,) => {
    return [
    `/api/chat/rooms/${roomId}`
    ] as const;
    }


export const getGetChatRoomQueryOptions = <TData = Awaited<ReturnType<typeof getChatRoom>>, TError = ErrorType<ApiError>>(roomId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getChatRoom>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatRoomQueryKey(roomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatRoom>>> = ({ signal }) => getChatRoom(roomId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: roomId !== null && roomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatRoom>>, TError, TData> & { queryKey: QueryKey }
}

export type GetChatRoomQueryResult = NonNullable<Awaited<ReturnType<typeof getChatRoom>>>
export type GetChatRoomQueryError = ErrorType<ApiError>


/**
 * @summary Get chat room info
 */

export function useGetChatRoom<TData = Awaited<ReturnType<typeof getChatRoom>>, TError = ErrorType<ApiError>>(
 roomId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getChatRoom>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetChatRoomQueryOptions(roomId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







